import React from 'react';
import { Box } from '@mui/material';

/**
 * TabPanel Component - Shared component for tab content display
 * Extracted from individual Content components to eliminate duplication
 */
export interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

export function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;
	return (
		<Box role="tabpanel" hidden={value !== index} sx={{ height: '100%' }} {...other}>
			{children}
		</Box>
	);
}

